import api from "src/apis/api";

// Site-visit geofences are regular geofences with purpose="site_visit" scoped
// to a project. These wrap the shared /geofences endpoints with that purpose.

export async function fetchProjectGeofences(projectId) {
  const params = new URLSearchParams({ purpose: "site_visit", project_id: projectId });
  const { data } = await api.get(`/api/v1/geofences?${params}`);
  return data.geofences || [];
}

export async function createProjectGeofence(projectId, payload) {
  const { data } = await api.post("/api/v1/geofences", {
    geofence: { ...payload, purpose: "site_visit", project_id: projectId },
  });
  return data;
}

export async function updateProjectGeofence(id, payload) {
  const { data } = await api.patch(`/api/v1/geofences/${id}`, { geofence: payload });
  return data;
}

export async function deactivateProjectGeofence(id) {
  const { data } = await api.delete(`/api/v1/geofences/${id}`);
  return data;
}
